module.exports = __webpack_public_path__ + "static/media/share.f5fa18fa.svg";